/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Menu_Sync_ChangesInputs */

const en_team_menu_sync_changes = /** @type {(inputs: Team_Menu_Sync_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sync Changes`)
};

const fr_team_menu_sync_changes = /** @type {(inputs: Team_Menu_Sync_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchroniser les changements`)
};

const de_team_menu_sync_changes = /** @type {(inputs: Team_Menu_Sync_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderungen synchronisieren`)
};

const it_team_menu_sync_changes = /** @type {(inputs: Team_Menu_Sync_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronizza modifiche`)
};

const ru_team_menu_sync_changes = /** @type {(inputs: Team_Menu_Sync_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменения синхронизации`)
};

const es_team_menu_sync_changes = /** @type {(inputs: Team_Menu_Sync_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronizar cambios`)
};

const zh_cn2_team_menu_sync_changes = /** @type {(inputs: Team_Menu_Sync_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同步更改`)
};

const ja_team_menu_sync_changes = /** @type {(inputs: Team_Menu_Sync_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変更を同期`)
};

const hi_team_menu_sync_changes = /** @type {(inputs: Team_Menu_Sync_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परिवर्तनों को सिंक्रनाइज़ करें`)
};

const pt_pt2_team_menu_sync_changes = /** @type {(inputs: Team_Menu_Sync_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronizar alterações`)
};

/**
* | output |
* | --- |
* | "Sync Changes" |
*
* @param {Team_Menu_Sync_ChangesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_menu_sync_changes = /** @type {((inputs?: Team_Menu_Sync_ChangesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Menu_Sync_ChangesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_menu_sync_changes(inputs)
	if (locale === "de") return de_team_menu_sync_changes(inputs)
	if (locale === "it") return it_team_menu_sync_changes(inputs)
	if (locale === "ru") return ru_team_menu_sync_changes(inputs)
	if (locale === "es") return es_team_menu_sync_changes(inputs)
	if (locale === "zh-CN") return zh_cn2_team_menu_sync_changes(inputs)
	if (locale === "ja") return ja_team_menu_sync_changes(inputs)
	if (locale === "hi") return hi_team_menu_sync_changes(inputs)
	if (locale === "pt-PT") return pt_pt2_team_menu_sync_changes(inputs)
	return en_team_menu_sync_changes(inputs)
});